import React, { useState, useEffect } from "react";
import { purple } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import ReactSelect from "react-select";
import { FormControl, InputLabel } from "@material-ui/core";
import PropTypes from "prop-types";

const MultiValue = props => {
  const label = props.selectProps.getOptionLabel(props.data);
  return props.index > 0 ? ", " + label : label;
};

const Select = React.forwardRef((props, ref) => {
  const {
    customProperties,
    returnFullObject,
    noOptionsMessage,
    openMenuOnFocus,
    backgroundColor,
    getOptionValue,
    getOptionLabel,
    maxHeightMenu,
    filterOption,
    isSearchable,
    handleChange,
    tabIndex,
    isClearable,
    autoFocus,
    disabled,
    required,
    multiple,
    options,
    label,
    code,
    erro,
    id
  } = props;

  const classes = useStyles(props);

  const obterValoresSelecao = () => {
    let valores = [];

    if (code === null || code === undefined) return null;

    if (multiple) {
      code.forEach(item => {
        if (returnFullObject)
          valores.push(
            options.filter(option => getOptionValue(option) === getOptionValue(item))[0]
          );
        else valores.push(options.filter(option => getOptionValue(option) === item)[0]);
      });
      return valores;
    }

    return options.find(o => getOptionValue(o) === code);
  };

  const value = obterValoresSelecao();
  const realLabel = required ? label + "*" : label;
  const [selectedField, setSelectedField] = useState(null);
  const [errorBehavior, setErrorBehavior] = useState(false);

  useEffect(() => {
    setErrorBehavior((!selectedField && selectedField !== null && !value && required) || erro);
  }, [selectedField, value, required, erro]);

  const handleSelectOption = option => {
    if (multiple) {
      handleChange(returnFullObject ? option : option.map(o => getOptionValue(o)));
    } else {
      let teste = option && getOptionValue(option);
      handleChange(returnFullObject ? option : teste);
    }
  };

  const temValorSelecionado = multiple ? value && value.length > 0 : value;
  return (
    <FormControl
      id="form"
      variant="outlined"
      className={classes.input}
      onClick={() => setSelectedField(true)}
    >
      {temValorSelecionado && (
        <InputLabel
          style={{
            color:
              errorBehavior && !disabled
                ? "#f44336"
                : selectedField && !disabled
                ? purple["A200"]
                : "rgba(0, 0, 0, 0.54)",
            backgroundImage: disabled
              ? "linear-gradient(180deg, transparent 50%, hsl(0,0%,95%) 50%)"
              : "none"
          }}
          className={classes.floatLabel}
          htmlFor="outlined-age-native-simple"
        >
          {realLabel}
        </InputLabel>
      )}
      <ReactSelect
        {...customProperties}
        components={{ MultiValue }}
        noOptionsMessage={() => noOptionsMessage}
        onBlur={() => setSelectedField(false)}
        styles={styles(errorBehavior, maxHeightMenu, backgroundColor)}
        getOptionValue={getOptionValue}
        getOptionLabel={getOptionLabel}
        onChange={handleSelectOption}
        placeholder={realLabel}
        filterOption={filterOption}
        isDisabled={disabled}
        isClearable={isClearable}
        className={classes.input}
        autoFocus={autoFocus}
        options={options}
        openMenuOnFocus={openMenuOnFocus}
        tabIndex={tabIndex}
        tabSelectsValue
        value={value}
        id={id}
        isMulti={multiple}
        isSearchable={!multiple || isSearchable}
        closeMenuOnSelect={!multiple}
        hideSelectedOptions={false}
        ref={ref}
      />
    </FormControl>
  );
});

const styles = (errorBehavior, maxHeight, backgroundColor) => ({
  menuList: styles => ({ ...styles, maxHeight: maxHeight }),
  menu: styles => ({ ...styles, zIndex: 3 }),
  input: provided => ({
    ...provided,
    width: "100%",
    fontFamily: "CircularStd-Book",
    fontSize: "16px",
    margin: "0px",
    paddingTop: "0px",
    paddingBottom: "0px"
  }),
  singleValue: provided => ({
    ...provided,
    fontSize: "16px"
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: "CircularStd-Book",
    fontSize: "1rem",
    color: errorBehavior ? "#f44336" : "rgba(0, 0, 0, 0.54)"
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    ":hover": {
      borderColor: errorBehavior ? "#f44336" : isFocused ? purple["A200"] : "black"
    },
    boxShadow: isFocused ? `0 0 0 1px ${purple["A200"]}` : "none",
    borderColor: errorBehavior ? "#f44336" : isFocused ? purple["A200"] : "hsl(0, 0%, 70%)",
    backgroundColor: backgroundColor ? backgroundColor : "white"
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled ? null : isSelected || isFocused ? "hsl(0,0%,95%)" : null,
      cursor: "pointer",
      color: "rgba(0,0,0,0.54)",
      ":active": {
        ...styles[":active"],
        backgroundColor: "transparent"
      }
    };
  },
  valueContainer: base => ({
    ...base,
    height: "auto",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "block",
    width: "100%",
    fontFamily: "CircularStd-Book",
    fontSize: "16px",
    paddingTop: "16px",
    paddingBottom: "16px"
  })
});

const useStyles = makeStyles({
  input: {
    width: "100%",
    maxHeight: "100px"
  },
  disabled: {
    backgroundColor: "rgb(242, 242, 242)",
    borderColor: "rgb(230, 230, 230)"
  },
  floatLabel: {
    backgroundColor: props => (props.backgroundColor ? props.backgroundColor : "white"),
    transform: "scale(0.75)",
    padding: "0 8px 0 8px",
    position: "absolute",
    fontSize: "1rem",
    lineHeight: "1",
    height: "16px",
    top: "-6px",
    left: "6px"
  }
});

Select.propTypes = {
  /** Código da opção selecionada */
  code: PropTypes.any,
  /** Propriedades do componente ReactSelect que não estão mapeadas nas props, podem ser adicionadas nesse objeto */
  customProperties: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  /** Se essa prop for true, a function handleChange receberá como parâmetro o objeto completo da opção */
  returnFullObject: PropTypes.bool,
  /** Mensagem exibida caso não haja opções disponíveis */
  noOptionsMessage: PropTypes.string,
  maxHeightMenu: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  /** Espera-se um array de objetos com as propriedades 'codigo' e 'descricao' */
  options: PropTypes.array,
  id: PropTypes.string,
  openMenuOnFocus: PropTypes.bool,
  /** Function para pesquisa de opções */
  filterOption: PropTypes.func,
  getOptionValue: PropTypes.func,
  getOptionLabel: PropTypes.func,
  backgroundColor: PropTypes.string,
  erro: PropTypes.bool
};

Select.defaultProps = {
  noOptionsMessage: "Sem opções",
  returnFullObject: false,
  customProperties: {},
  required: false,
  maxHeightMenu: "300px",
  disabled: false,
  isClearable: false,
  autoFocus: false,
  label: "",
  code: null,
  options: [],
  id: "",
  openMenuOnFocus: true,
  multiple: false,
  getOptionValue: option => option.codigo,
  getOptionLabel: option => option.descricao,
  filterOption: (option, text) =>
    option.label.toString().toUpperCase().startsWith(text.toUpperCase()),
  backgroundColor: "white",
  erro: false
};

export default Select;
